import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Images, UploadSimple } from "@phosphor-icons/react";
import { comprimirImagem } from "@/lib/imagem";

const MODELOS_COM_SUPERVISORA = ["dnit_to"];

// Modelo de relatório fotográfico exigido pelo órgão deste contrato (padrão ao gerar; pode ser trocado na hora)
export function ModeloRelatorioFotografico({ contrato, onChange }) {
  const { user } = useAuth();
  const podeEditar = user?.role === "admin" || user?.role === "gestor";
  const [modelos, setModelos] = useState([]);
  const [padraoErp, setPadraoErp] = useState("padrao");
  const [supNome, setSupNome] = useState(contrato.supervisora_nome || "");

  useEffect(() => {
    api.get("/relatorios-fotograficos/modelos").then((r) => { setModelos(r.data?.modelos || []); setPadraoErp(r.data?.padrao || "padrao"); }).catch(() => null);
  }, []);
  useEffect(() => { setSupNome(contrato.supervisora_nome || ""); }, [contrato.supervisora_nome]);

  const atual = contrato.modelo_relatorio_fotografico || padraoErp;
  const salvar = async (extra) => {
    try { await api.put(`/contratos/${contrato.id}/relatorio-fotografico`, { modelo: atual, ...extra }); toast.success("Relatório fotográfico do contrato atualizado"); onChange?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
  };
  const enviarLogo = async (e) => {
    const f = e.target.files[0]; e.target.value = "";
    if (!f) return;
    try { salvar({ supervisora_logo: await comprimirImagem(f, 600, 300000) }); } catch (err) { toast.error(err.message); }
  };

  return (
    <div className="pcp-card" style={{ padding: "12px 16px", marginTop: 20 }} data-testid="modelo-relatorio-fotografico">
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <Images size={18} weight="bold" />
        <div style={{ flex: 1, minWidth: 220 }}>
          <div className="font-display font-bold" style={{ fontSize: "0.9rem" }}>Relatório fotográfico — modelo exigido pelo órgão</div>
          <div className="text-xs" style={{ color: "#71717A" }}>{modelos.find((m) => m.id === atual)?.descricao || "Usado por padrão ao gerar o relatório das OS deste contrato; pode ser trocado na hora de gerar."}</div>
        </div>
        {podeEditar ? (
          <select className="input" style={{ width: 260 }} value={atual} onChange={(e) => salvar({ modelo: e.target.value })} data-testid="select-modelo-relatorio">
            {modelos.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
          </select>
        ) : <span className="font-semibold text-sm" data-testid="modelo-relatorio-atual">{modelos.find((m) => m.id === atual)?.nome || atual}</span>}
      </div>
      {MODELOS_COM_SUPERVISORA.includes(atual) && (
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 12, paddingTop: 12, borderTop: "1px solid #E4E4E7" }} data-testid="supervisora-area">
          <div style={{ width: 150, height: 52, border: "1px dashed #D4D4D8", borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff", overflow: "hidden" }}>
            {contrato.supervisora_logo ? <img src={contrato.supervisora_logo} alt="logo supervisora" style={{ maxWidth: 146, maxHeight: 48, objectFit: "contain" }} data-testid="supervisora-logo-preview" /> : <span style={{ fontSize: "0.7rem", color: "#A1A1AA" }}>logo da supervisora</span>}
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div className="label">Supervisora / fiscalização do contrato (logo no cabeçalho, ao lado do órgão)</div>
            <input className="input" value={supNome} disabled={!podeEditar} onChange={(e) => setSupNome(e.target.value)} onBlur={() => supNome !== (contrato.supervisora_nome || "") && salvar({ supervisora_nome: supNome })} placeholder="Ex: Consórcio HOUER Consane" data-testid="supervisora-nome" />
          </div>
          {podeEditar && (
            <div style={{ display: "flex", gap: 6 }}>
              <label className="btn btn-outline btn-sm" style={{ cursor: "pointer" }}><UploadSimple size={14} weight="bold" /> {contrato.supervisora_logo ? "Trocar logo" : "Enviar logo"}
                <input type="file" accept="image/png,image/jpeg" style={{ display: "none" }} onChange={enviarLogo} data-testid="supervisora-logo-input" />
              </label>
              {contrato.supervisora_logo && <button type="button" className="btn btn-ghost btn-sm" onClick={() => salvar({ supervisora_logo: "" })} data-testid="supervisora-logo-remover">Remover</button>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
